var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJimThor5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_7502_41426)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93555 22.2559C9.74023 22.2559 9.56836 22.2422 9.41992 22.2148C9.27148 22.1875 9.14453 22.1504 9.03906 22.1035V21.2539C9.16406 21.293 9.29883 21.3223 9.44336 21.3418C9.58789 21.3652 9.74414 21.377 9.91211 21.377C10.1309 21.377 10.332 21.334 10.5156 21.248C10.6992 21.1621 10.8457 21.0156 10.9551 20.8086C11.0645 20.6016 11.1191 20.3164 11.1191 19.9531V11.4336H12.1211V19.877C12.1211 20.4121 12.0312 20.8555 11.8516 21.207C11.6758 21.5586 11.4238 21.8203 11.0957 21.9922C10.7715 22.168 10.3848 22.2559 9.93555 22.2559ZM17.0254 20H16.0234V12.3125H13.3281V11.4336H19.709V12.3125H17.0254V20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7502_41426",
    x1: 45,
    y1: 15,
    x2: 15,
    y2: -15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJimThor5);
export default __webpack_public_path__ + "static/media/Jim-Thor-5.00078d865ce9263cc57f7edb3ef36ed3.svg";
export { ForwardRef as ReactComponent };